module.exports = __webpack_public_path__ + "static/media/sample-golfer.53e7e941.png";